<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-history-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">Reconstitution du stock d'une matière première</h4>
                                <p class="cf-modal-head__sub">Chaque mouvement avec le stock avant et après, l'article vendu, la facture et la caisse</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- ========== TOOLBAR ========== -->
                    <div class="cf-dialog-toolbar">
                        <div class="cf-toolbar-row">
                            <div class="rs-field">
                                <label>Entrepôt</label>
                                <select v-model="pidmag" class="cf-inp cf-select" @change="surChangementEntrepot">
                                    <option value="">Tous les entrepôts</option>
                                    <option v-for="magasin in listemagasins" :key="magasin.pid" :value="magasin.pid">{{ magasin.name }}</option>
                                </select>
                            </div>
                            <div class="rs-field rs-field--grow">
                                <label>Matière première</label>
                                <select v-model="cle" class="cf-inp cf-select">
                                    <option value="">Choisir une matière première</option>
                                    <option v-for="matiere in matieresFiltrees" :key="matiere.cle" :value="matiere.cle">
                                        {{ matiere.libelle }}{{ pidmag==='' && listemagasins.length>1 ? ' ('+matiere.magasin+')' : '' }}{{ matiere.inventaireRecommande ? ' (inventaire recommandé)' : '' }}
                                    </option>
                                </select>
                            </div>
                            <div class="rs-field">
                                <label>Du</label>
                                <input v-model="dateDebut" type="date" class="cf-inp">
                            </div>
                            <div class="rs-field">
                                <label>Au</label>
                                <input v-model="dateFin" type="date" class="cf-inp">
                            </div>
                            <button @click="load" :disabled="loading" type="button" class="ti-btn ti-btn-primary-full rs-btn">
                                <i class="ri-refresh-line"></i> {{ loading ? 'Chargement…' : 'Afficher' }}
                            </button>
                        </div>
                        <div class="rs-tools">
                            <label class="cf-check">
                                <input v-model="seulementRuptures" type="checkbox"> Seulement les ruptures de continuité
                            </label>
                            <div class="search-wrap rs-search">
                                <i class="ri-search-line search-icon"></i>
                                <input v-model="searchword" type="search" class="search-input" placeholder="Facture, article, utilisateur...">
                            </div>
                            <button @click="exporter" :disabled="!lignes.length" type="button" class="ti-btn ti-btn-light rs-btn">
                                <i class="ri-file-excel-2-line"></i> Exporter
                            </button>
                            <button @click="imprimer" :disabled="!lignes.length" type="button" class="ti-btn ti-btn-light rs-btn">
                                <i class="ri-printer-line"></i> Imprimer
                            </button>
                        </div>
                    </div>

                    <!-- ========== BODY ========== -->
                    <div class="cf-dialog-body">

                        <div v-if="!activation.actif && charge" class="rs-alert rs-alert--info">
                            <b>Journal détaillé non activé pour cette société.</b>
                            <span>Les mouvements affichés viennent de l'ancien journal du stock : l'article vendu et la portion par unité n'y figurent pas.</span>
                        </div>

                        <alertesmatieres v-if="charge" :pidmag="pidmag"></alertesmatieres>

                        <div v-if="matieresARecompter.length" class="rs-alert">
                            <b>{{ matieresARecompter.length }} matière(s) première(s) à inventorier</b>
                            <span>Leur stock est négatif, ou aucun inventaire n'a été saisi depuis la mise en service du nouveau déstockage. Saisissez un mouvement d'inventaire pour repartir d'un stock juste : {{ apercuARecompter }}</span>
                        </div>

                        <div v-if="loading" class="animate-pulse cf-skeleton">
                            <div class="cf-skeleton-bar"></div>
                            <div class="cf-skeleton-bar"></div>
                            <div class="cf-skeleton-bar"></div>
                            <div class="cf-skeleton-bar"></div>
                        </div>

                        <template v-else-if="resume">

                            <div class="rs-kpis">
                                <div class="rs-kpi">
                                    <span class="rs-kpi__label">Stock au début de la période</span>
                                    <span class="rs-kpi__value">{{ formatQte(resume.stockDebut) }} <small>{{ matiere.unite }}</small></span>
                                </div>
                                <div class="rs-kpi">
                                    <span class="rs-kpi__label">Entrées</span>
                                    <span class="rs-kpi__value rs-ok">+ {{ formatQte(resume.totalEntrees) }}</span>
                                </div>
                                <div class="rs-kpi">
                                    <span class="rs-kpi__label">Sorties</span>
                                    <span class="rs-kpi__value rs-ko">- {{ formatQte(resume.totalSorties) }}</span>
                                </div>
                                <div class="rs-kpi">
                                    <span class="rs-kpi__label">Stock à la fin de la période</span>
                                    <span class="rs-kpi__value">{{ formatQte(resume.stockFin) }}</span>
                                </div>
                                <div class="rs-kpi">
                                    <span class="rs-kpi__label">Stock actuel</span>
                                    <span class="rs-kpi__value" :class="{ 'rs-ko': resume.stockActuel<0 }">{{ formatQte(resume.stockActuel) }}</span>
                                </div>
                                <div class="rs-kpi">
                                    <span class="rs-kpi__label">Ruptures de continuité</span>
                                    <span class="rs-kpi__value" :class="resume.nbRuptures>0 ? 'rs-ko' : 'rs-ok'">
                                        {{ resume.nbRuptures }}
                                        <small v-if="resume.nbRuptures>0">(écart {{ formatSigne(resume.ecartNonJournalise) }})</small>
                                    </span>
                                </div>
                            </div>

                            <div v-if="resume.tronque" class="rs-alert">
                                <b>Période trop longue</b>
                                <span>Seuls les {{ resume.nbLignes }} premiers mouvements sont affichés. Réduisez la période pour voir la suite.</span>
                            </div>

                            <div class="table-scroll-wrap rs-scroll">
                                <table class="rs-table">
                                    <thead>
                                    <tr>
                                        <th class="th">Date</th>
                                        <th class="th">Document</th>
                                        <th class="th">Mouvement</th>
                                        <th class="th">Caisse</th>
                                        <th class="th">Utilisateur</th>
                                        <th class="th">Article vendu</th>
                                        <th class="th th--right">Qté vendue</th>
                                        <th class="th th--right">Portion par unité</th>
                                        <th class="th th--right">Ancienne portion</th>
                                        <th class="th th--right">Portion déstockée</th>
                                        <th class="th th--right">Variation</th>
                                        <th class="th th--right">Stock initial</th>
                                        <th class="th th--right">Stock final</th>
                                        <th class="th">Contrôle</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-if="lignesFiltrees.length">
                                        <tr class="table-row" :class="{ 'rs-row-ko': ligne.rupture }" v-for="(ligne,index) in lignesFiltrees" :key="index">
                                            <td class="td">{{ ligne.date }}</td>
                                            <td class="td cf-strong">{{ ligne.numdoc || '-' }}</td>
                                            <td class="td">
                                                {{ libelleMouvement(ligne) }}
                                                <span v-if="ligne.source==='ancien'" class="cf-st cf-st--warn rs-tag" title="Mouvement issu de l'ancien journal : détail incomplet">Ancien journal</span>
                                            </td>
                                            <td class="td">{{ ligne.caisse || '-' }}</td>
                                            <td class="td">{{ ligne.utilisateur || '-' }}</td>
                                            <td class="td">{{ ligne.article || '-' }}</td>
                                            <td class="td td--right">{{ ligne.source==='journal' ? formatVendu(ligne) : '-' }}</td>
                                            <td class="td td--right">{{ ligne.source==='journal' ? formatQte(ligne.portionUnitaire) : '-' }}</td>
                                            <td class="td td--right">{{ formatQte(ligne.portionOld) }}</td>
                                            <td class="td td--right">{{ formatQte(ligne.portionNew) }}</td>
                                            <td class="td td--right cf-strong" :class="ligne.variation<0 ? 'rs-ko' : (ligne.variation>0 ? 'rs-ok' : '')">{{ formatSigne(ligne.variation) }}</td>
                                            <td class="td td--right">{{ formatQte(ligne.stockAvant) }}</td>
                                            <td class="td td--right cf-strong">{{ formatQte(ligne.stockApres) }}</td>
                                            <td class="td">
                                                <span v-if="ligne.rupture" class="cf-st cf-st--ko" title="Le stock de départ ne correspond pas au stock final de la ligne précédente : une modification du stock n'a pas été journalisée">Rupture {{ formatSigne(ligne.ecart) }}</span>
                                                <span v-else-if="ligne.note && ligne.note.indexOf('Ingrédient')===0" class="cf-st cf-st--info" :title="ligne.note">{{ ligne.note }}</span>
                                                <span v-else-if="ligne.note" class="cf-st cf-st--warn" :title="ligne.note">À vérifier</span>
                                                <span v-else class="rs-muted">OK</span>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr><td colspan="14" class="td"><div class="empty-state"><div class="empty-state__icon"><i class="ri-inbox-line"></i></div><p class="empty-state__title">Aucun mouvement sur cette période</p></div></td></tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>

                            <p class="rs-note">
                                {{ resume.nbLignes }} mouvement(s), dont {{ resume.nbJournal }} détaillé(s) et {{ resume.nbAncien }} issu(s) de l'ancien journal.
                                Une rupture signale que le stock a été modifié sans être journalisé entre deux lignes.
                            </p>

                        </template>

                        <div v-else class="empty-state">
                            <div class="empty-state__icon"><i class="ri-flask-line"></i></div>
                            <p class="empty-state__title">Choisissez une matière première et une période, puis cliquez sur Afficher</p>
                        </div>

                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import alertesmatieres from "@/components/views/pages/stock/fichetechnique/alertesmatieres";
    const axios =require('axios');

    const formatJour = (date) => {
        let mois=('0'+(date.getMonth()+1)).slice(-2), jour=('0'+date.getDate()).slice(-2);
        return date.getFullYear()+'-'+mois+'-'+jour;
    };

    const LIBELLES_ORIGINE={
        cuisine:' (cuisine)', comptabilisation:' (contrôle à la comptabilisation)', cloture:' (clôture de caisse)',
    };

    const LIBELLES_TYPE={
        F:'Vente', ME:"Mouvement d'entrée", MS:'Mouvement de sortie', MI:'Inventaire', MT:'Transfert',
    };

    export default {
        /* eslint-disable */
        name: "modalreconstitutionstock",

        components:{ alertesmatieres },

        computed:{

            listemagasins(){
                let vus={},mvalue=[];
                this.matieres.forEach(function (matiere) {
                    if (!vus[matiere.pidmag]){
                        vus[matiere.pidmag]=true;
                        mvalue.push({pid:matiere.pidmag,name:matiere.magasin || matiere.pidmag});
                    }
                });
                return mvalue;
            },

            matieresFiltrees(){
                let t=this;
                if (this.pidmag==='') return this.matieres;
                return this.matieres.filter(function (matiere) { return matiere.pidmag===t.pidmag });
            },

            matieresARecompter(){
                return this.matieresFiltrees.filter(function (matiere) { return matiere.inventaireRecommande });
            },

            apercuARecompter(){
                let noms=this.matieresARecompter.slice(0,8).map(function (matiere) { return matiere.libelle });
                let reste=this.matieresARecompter.length-noms.length;
                return noms.join(', ')+(reste>0?' et '+reste+' autre(s)':'')+'.';
            },

            lignesFiltrees(){
                let mot=this.searchword.toLowerCase(),mvalue=this.lignes;

                if (this.seulementRuptures){
                    mvalue=mvalue.filter(function (ligne) { return ligne.rupture });
                }

                if (mot!==''){
                    mvalue=mvalue.filter(function (ligne) {
                        return (ligne.numdoc+' '+ligne.article+' '+ligne.utilisateur+' '+ligne.caisse+' '+ligne.libelle).toLowerCase().includes(mot)
                    });
                }

                return mvalue;
            },
        },

        data() {
            return {
                isdisplay:false,
                loading:false,
                charge:false,
                searchword:"",
                seulementRuptures:false,
                dateDebut:"",
                dateFin:"",
                pidmag:"",
                cle:"",
                activation:{actif:false,activeLe:""},
                matieres:[],
                matiere:{libelle:"",unite:"",magasin:""},
                periode:{debut:"",fin:""},
                resume:null,
                lignes:[],
            };
        },

        methods: {

            entetes(){
                return {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + JwtService.getToken(),
                    'csrftoken': this.$store.state.appsociete
                };
            },

            formatQte(value){
                let n=Number(value);
                if (isNaN(n)) return '0';
                return n.toLocaleString('fr-FR',{maximumFractionDigits:3});
            },

            formatSigne(value){
                let n=Number(value);
                if (isNaN(n) || n===0) return '0';
                return (n>0?'+ ':'- ')+Math.abs(n).toLocaleString('fr-FR',{maximumFractionDigits:3});
            },

            formatVendu(ligne){
                if (ligne.action==='ADD') return this.formatQte(ligne.qteVendueNew);
                return this.formatQte(ligne.qteVendueOld)+' → '+this.formatQte(ligne.qteVendueNew);
            },

            libelleMouvement(ligne){

                if (ligne.source==='journal'){
                    let origine=LIBELLES_ORIGINE[ligne.origine] || '';
                    if (ligne.origine==='annulation') return 'Facture annulée : restitution';
                    if (ligne.action==='ADD') return 'Vente'+origine;
                    if (ligne.action==='UPDATE') return 'Quantité vendue modifiée'+origine;
                    if (ligne.action==='DELETE') return 'Vente supprimée : restitution'+origine;
                    return ligne.libelle;
                }

                return ligne.libelle || LIBELLES_TYPE[ligne.typdoc] || ligne.typdoc || '-';
            },

            show(){

                let fin=new Date(),debut=new Date();
                debut.setDate(debut.getDate()-29);

                this.dateDebut=formatJour(debut);
                this.dateFin=formatJour(fin);
                this.pidmag="";
                this.cle="";
                this.searchword="";
                this.seulementRuptures=false;
                this.resume=null;
                this.lignes=[];
                this.charge=false;

                this.isdisplay=true;

                this.loadMatieres();

            },

            close(){
                this.isdisplay=false;
            },

            surChangementEntrepot(){
                let t=this;
                let encore=this.matieresFiltrees.some(function (matiere) { return matiere.cle===t.cle });
                if (!encore){
                    this.cle="";
                    this.resume=null;
                    this.lignes=[];
                }
            },

            async loadMatieres(){

                const t = this;
                this.loading=true;

                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/reconstitution/matieres/'+this.$store.state.appsociete+'/'+randomString();

                try {

                    let res=await axios.post(url,{},{headers: this.entetes() ,withCredentials: true});

                    if (res.data.success){
                        t.activation=res.data.m.activation;
                        t.matieres=res.data.m.matieres.map(function (matiere) {
                            matiere.cle=matiere.pid+'|'+matiere.pidmag;
                            return matiere;
                        });
                        t.charge=true;
                    }else{
                        toastr['error']( res.data.message || "Chargement impossible.","<b></b>");
                    }

                }catch (error) {
                    toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.","<b>Erreur</b>")
                }

                this.loading=false;

            },

            async load(){

                let t=this;
                let choix=this.matieres.find(function (matiere) { return matiere.cle===t.cle });

                if (!choix){
                    toastr['error']( "Veuillez choisir une matière première.","<b></b>");
                    return;
                }

                if (this.dateDebut==="" || this.dateFin===""){
                    toastr['error']( "Veuillez choisir la période.","<b></b>");
                    return;
                }

                if (this.dateDebut>this.dateFin){
                    toastr['error']( "La date de début doit précéder la date de fin.","<b></b>");
                    return;
                }

                this.loading=true;

                let url=process.env.VUE_APP_API_URL+'/egl745874pstock771714dfe/fichetechnique/reconstitution/mouvements/'+this.$store.state.appsociete+'/'+randomString();

                try {

                    let res=await axios.post(url,{
                        pidmatiere:choix.pid,
                        pidmag:choix.pidmag,
                        dateDebut:this.dateDebut,
                        dateFin:this.dateFin,
                    },{headers: this.entetes() ,withCredentials: true});

                    if (res.data.success){
                        t.periode=res.data.m.periode;
                        t.matiere=res.data.m.matiere;
                        t.resume=res.data.m.resume;
                        t.lignes=res.data.m.lignes;
                    }else{
                        toastr['error']( res.data.message || "Chargement impossible.","<b></b>");
                    }

                }catch (error) {
                    toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.","<b>Erreur</b>")
                }

                this.loading=false;

            },

            echapper(value){
                return String(value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
            },

            colonnes(ligne){
                return [
                    ligne.date,
                    ligne.numdoc || '',
                    this.libelleMouvement(ligne)+(ligne.source==='ancien'?' (ancien journal)':''),
                    ligne.caisse || '',
                    ligne.utilisateur || '',
                    ligne.article || '',
                    ligne.source==='journal'?this.formatVendu(ligne):'',
                    ligne.source==='journal'?this.formatQte(ligne.portionUnitaire):'',
                    this.formatQte(ligne.portionOld),
                    this.formatQte(ligne.portionNew),
                    this.formatSigne(ligne.variation),
                    this.formatQte(ligne.stockAvant),
                    this.formatQte(ligne.stockApres),
                    ligne.rupture?'Rupture '+this.formatSigne(ligne.ecart):(ligne.note || 'OK'),
                ];
            },

            titres(){
                return ['Date','Document','Mouvement','Caisse','Utilisateur','Article vendu','Qté vendue','Portion par unité',
                    'Ancienne portion','Portion déstockée','Variation','Stock initial','Stock final','Contrôle'];
            },

            exporter(){

                let t=this;
                let champ=function (value) { return '"'+String(value).replace(/"/g,'""')+'"' };

                let contenu=[this.titres().map(champ).join(';')]
                    .concat(this.lignesFiltrees.map(function (ligne) { return t.colonnes(ligne).map(champ).join(';') }))
                    .join('\r\n');

                let blob=new Blob(['﻿'+contenu],{type:'text/csv;charset=utf-8;'});
                let lien=document.createElement('a');
                lien.href=URL.createObjectURL(blob);
                lien.download='reconstitution_stock_'+this.matiere.libelle.replace(/[^a-zA-Z0-9]+/g,'_')+'_'+this.periode.debut+'_'+this.periode.fin+'.csv';
                document.body.appendChild(lien);
                lien.click();
                document.body.removeChild(lien);
                URL.revokeObjectURL(lien.href);

            },

            imprimer(){

                let t=this;
                let droite=[6,7,8,9,10,11,12];

                let rows=this.lignesFiltrees.map(function (ligne) {
                    return '<tr'+(ligne.rupture?' class="ko"':'')+'>'+t.colonnes(ligne).map(function (value,index) {
                        return '<td'+(droite.indexOf(index)>=0?' class="r"':'')+'>'+t.echapper(value)+'</td>';
                    }).join('')+'</tr>';
                }).join('');

                let html='<html><head><meta charset="utf-8"><title>Reconstitution du stock</title><style>'
                    +'@page{size:landscape;margin:10mm}'
                    +'body{font-family:Arial,sans-serif;font-size:10px;color:#111;margin:12px}'
                    +'h2{margin:0 0 4px;font-size:15px}p{margin:0 0 10px;color:#444}'
                    +'table{width:100%;border-collapse:collapse}th,td{border:1px solid #999;padding:3px 5px;text-align:left}'
                    +'th{background:#eee}.r{text-align:right}.ko td{background:#fde2e2}'
                    +'</style></head><body>'
                    +'<h2>Reconstitution du stock : '+this.echapper(this.matiere.libelle)+' ('+this.echapper(this.matiere.unite)+')</h2>'
                    +'<p>Entrepôt : '+this.echapper(this.matiere.magasin || '-')+' | Période du '+this.periode.debut+' au '+this.periode.fin
                    +' | Stock début : '+this.formatQte(this.resume.stockDebut)+' | Entrées : '+this.formatQte(this.resume.totalEntrees)
                    +' | Sorties : '+this.formatQte(this.resume.totalSorties)+' | Stock fin : '+this.formatQte(this.resume.stockFin)
                    +' | Ruptures : '+this.resume.nbRuptures+'</p>'
                    +'<table><thead><tr>'+this.titres().map(function (titre,index) {
                        return '<th'+(droite.indexOf(index)>=0?' class="r"':'')+'>'+t.echapper(titre)+'</th>';
                    }).join('')+'</tr></thead>'
                    +'<tbody>'+rows+'</tbody>'
                    +'</table></body></html>';

                let fenetre=window.open('','_blank');

                if (!fenetre){
                    toastr['error']( "Le navigateur a bloqué la fenêtre d'impression.","<b></b>");
                    return;
                }

                fenetre.document.write(html);
                fenetre.document.close();
                fenetre.focus();
                fenetre.print();

            },

        },

    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; height:94vh; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1440px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-toolbar { padding:0.75rem 1.25rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }

/* Toolbar */
.cf-toolbar-row { display:flex; gap:0.75rem; align-items:flex-end; flex-wrap:wrap; }
.rs-field { display:flex; flex-direction:column; gap:3px; min-width:150px; }
.rs-field label { font-size:0.72rem; color:var(--cf-muted); }
.rs-field--grow { flex:1; min-width:240px; }
.cf-inp { width:100%; height:38px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-select { cursor:pointer; }
.rs-btn { height:38px; }
.rs-tools { display:flex; align-items:center; gap:0.75rem; flex-wrap:wrap; margin-top:0.7rem; }
.cf-check { display:inline-flex; align-items:center; gap:0.4rem; font-size:0.8rem; color:var(--cf-muted); cursor:pointer; }
.cf-check input { accent-color:rgb(var(--primary)); width:16px; height:16px; }
.search-wrap { position:relative; }
.rs-search { margin-left:auto; width:260px; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:8px 12px 8px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; background:#fff; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }

/* Indicateurs */
.rs-kpis { display:grid; grid-template-columns:repeat(auto-fit,minmax(170px,1fr)); gap:0.75rem; margin-bottom:0.9rem; }
.rs-kpi { background:var(--cf-surface); border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); padding:0.7rem 0.9rem; }
.rs-kpi__label { display:block; font-size:0.72rem; color:var(--cf-muted); margin-bottom:2px; }
.rs-kpi__value { font-size:1.1rem; font-weight:700; color:var(--cf-ink-strong); }
.rs-kpi__value small { font-size:0.7rem; font-weight:500; color:var(--cf-muted); }
.rs-ok { color:#15803d; }
.rs-ko { color:#b91c1c; }
.rs-muted { color:var(--cf-faint); font-size:0.75rem; }

/* Alertes */
.rs-alert { margin-bottom:0.8rem; padding:0.6rem 0.8rem; border-radius:var(--cf-radius-sm); background:#fef9c3; color:#a16207; font-size:0.8rem; display:flex; flex-direction:column; gap:3px; }
.rs-alert span { color:#713f12; white-space:normal; }
.rs-alert--info { background:rgb(var(--primary) / 0.06); color:rgb(var(--primary)); }
.rs-alert--info span { color:var(--cf-ink); }

/* Table */
.table-scroll-wrap { overflow:auto; }
.rs-scroll { border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); max-height:56vh; }
.rs-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:1320px; }
.th { position:sticky; top:0; z-index:2; padding:0.65rem 0.75rem; font-weight:600; font-size:0.74rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--right { text-align:right; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.rs-row-ko, .rs-row-ko:hover { background:#fef2f2; }
.td { padding:0.5rem 0.75rem; font-size:0.8rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--right { text-align:right; }
.cf-strong { font-weight:500; color:var(--cf-ink-strong); }
.td.rs-ok { color:#15803d; }
.td.rs-ko { color:#b91c1c; }
.rs-tag { margin-left:0.4rem; }
.rs-note { font-size:0.76rem; color:var(--cf-muted); margin:0.6rem 0 0; }

/* Skeleton */
.cf-skeleton { padding:1rem; }
.cf-skeleton-bar { height:0.9rem; border-radius:4px; background:var(--cf-surface-alt); margin-bottom:0.9rem; }
.cf-skeleton-bar:nth-child(even) { background:#e2e8f0; }

/* Empty state */
.empty-state { padding:2rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:36px; color:var(--cf-faint); margin-bottom:10px; }
.empty-state__title { font-size:0.92rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } .rs-search { margin-left:0; width:100%; } }
</style>
